import type { FC } from 'react';

import { Box } from '@mui/material';

import { UserNameInfoText } from './UserNameInfoBlock.style';

type PropsType = {
  firstInfo?: string | null;
  secondInfo?: string | null;
  maxWidthInfo?: string;
};

export const UserNameInfoBlock: FC<PropsType> = ({ firstInfo, secondInfo, maxWidthInfo = '242px' }) => (
  <Box sx={{ overflow: 'hidden' }}>
    <Box>
      <UserNameInfoText
        maxWidthInfo={maxWidthInfo}
        sx={(theme) => ({ color: theme.palette.case.neutral.n700 })}
        variant="t14r"
        noWrap
      >
        {firstInfo}
      </UserNameInfoText>
    </Box>

    <Box>
      <UserNameInfoText
        maxWidthInfo={maxWidthInfo}
        sx={(theme) => ({ color: theme.palette.case.neutral.n400 })}
        variant="t12r"
      >
        {secondInfo}
      </UserNameInfoText>
    </Box>
  </Box>
);
